import React, { useEffect, useState } from "react";
import Web3Modal from "web3modal";
import { ethers } from "ethers";
import { soulContractAddress } from "../config";

import SoulAbi from "../artifacts/contracts/Soul.sol/Soul.json";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Card from "../components/Card";

function Certificate(props) {
  const { certificate_id } = props;
  const [certificateList, setCertificateList] = useState([]);

  useEffect(() => {
    console.log("Certificate: ", certificate_id);
    loadCertificate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificate_id]);

  async function loadCertificate() {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();

    const SoulContract = new ethers.Contract(soulContractAddress, SoulAbi.abi, signer);
    let soulList = await SoulContract.getIssuerSouls(certificate_id);
    soulList = await Promise.all(
      soulList.map(async (i) => {
        const tokenUri = await SoulContract.tokenURI(i.soulId);
        let item = {
          owner: i.owner,
          issuer: i.issuer,
          show: i.show,
          rank: i.rank.toString(),
          soulId: i.soulId.toString(),
          description: i.description,
          tokenUri,
        };
        return item;
      })
    );
    console.log("item1: ", soulList);
    setCertificateList(soulList);
  }

  return (
    <>
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Hero content */}
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          <div className="grid gap-16 grid-cols-2">
            {certificateList.map((item, index) => {
              return <Card key={index} certificate={item} />;
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Certificate;
